export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["min"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kupić"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["za"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywne"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Link do ogłoszenia"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID makera"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opis"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Limit czasu"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Data utworzenia"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zapłacę"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Otrzymam"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Limit transakcji"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wszystko"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transakcje"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID oferty"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kurs"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybierz konto"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poza limitem"])}
}